import { api } from "../utils/AuthManager";

const GetGenerateClientDocuments = ({ id, signal }) => {
  return api.get(`/api/generate_client_documents/${id}`, {
    signal,
    responseType: "arraybuffer",
  });
};
export default GetGenerateClientDocuments;
